interface NavItem {
  label: string
  path: string
}

export const LoanApplicationPath = '/loan-application'
export const MakePaymentPath = '/payment-center'
export const ContactUsPath = '/contact-us'
export const OurLoansPath = '/our-loans'

export const AboutUs = '/about-us'
export const ResourcesPath = '/resources'
export const FAQsPath = '/faqs'
export const RatesTermsLicensesPath = '/rates-terms-licenses'
export const TermsOfUsePath = '/terms-of-use'
export const PrivacyPolicyPath = '/privacy-policy'
export const SMSPolicyPath = '/sms-policy'
export const TransactElectronicallyPath = '/electronic-transaction-consent'

export const NavbarItems: NavItem[] = [
  { label: 'Our Loans', path: OurLoansPath },
  { label: 'About Us', path: AboutUs },
  { label: 'FAQs', path: FAQsPath },
  { label: 'Resources', path: ResourcesPath },
  { label: 'Contact Us', path: ContactUsPath }
]

export const FooterItems: { [key: string]: NavItem[] } = {
  primary: NavbarItems.slice(0, 4),
  secondary: [
    { label: 'Apply Now', path: LoanApplicationPath },
    { label: 'Rates, Terms & Licenses', path: RatesTermsLicensesPath },
    { label: 'Terms of Use ', path: TermsOfUsePath },
    { label: 'Privacy Policy', path: PrivacyPolicyPath },
    { label: 'SMS Policy', path: SMSPolicyPath }
  ]
}
